import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

type OrderTax = OrdersModel.OrderTax & { finalAmount: number };

interface RefundTaxProps {
  readonly paymentTaxes?: OrderTax[];
  readonly includeGratuityTax?: OrdersModel.OrderDetail['include_gratuity_tax'];
}

function RefundTax({ paymentTaxes, includeGratuityTax }: RefundTaxProps) {
  return (paymentTaxes || []).length > 0 ? (
    <div className="mb-4">
      <Text weight="semibold" className=" py-2">
        Tax
      </Text>
      {paymentTaxes?.map((tax, idx) => {
        return (
          <div key={idx} className="flex justify-between border-t py-2">
            <Text>
              {tax.name} {includeGratuityTax && '(Included)'}
            </Text>
            <Text>{!includeGratuityTax && numberUtils.formatCurrency(tax.finalAmount, 'Rp.')}</Text>
          </div>
        );
      })}
    </div>
  ) : null;
}

export default RefundTax;
